const constants = {
  // new constants
  ACCEPT_TERMS: "ACCEPT_TERMS",
  CANCEL_SUBMIT: "CANCEL_SUBMIT",
  CONCLUSION_SUBMIT: "CONCLUSION_SUBMIT",
  CONTACT_SUBMIT: "CONTACT_SUBMIT",
  CULTURAL_BACKGROUND_SUBMIT: "CULTURAL_BACKGROUND_SUBMIT",
  DIET_SUBMIT: "DIET_SUBMIT",
  GO_BACK: "GO_BACK",
  GUEST_PACKAGES_SUBMIT: "GUEST_PACKAGES_SUBMIT",
  GUEST_PREFERENCES_SUBMIT: "GUEST_PREFERENCES_SUBMIT",
  HOLDING_SUBMIT: "HOLDING_SUBMIT",
  HOUSE_SUBMIT: "HOUSE_SUBMIT",
  FAMILY_INTERESTS_SUBMIT: "FAMILY_INTERESTS_SUBMIT",
  REFERENCES_SUBMIT: "REFERENCES_SUBMIT",
  INTERVAL_SUBMIT: "INTERVAL_SUBMIT",
  NEXT_PAGE: "NEXT_PAGE",
  PAYMENTS_SUBMIT: "PAYMENTS_SUBMIT",
  PETS_SUBMIT: "PETS_SUBMIT",
  PHOTO_SUBMIT: "PHOTO_SUBMIT",
  PROFILE_SUBMIT: "PROFILE_SUBMIT",
  REFERRAL_SUBMIT: "REFERRAL_SUBMIT",
  REGISTER_USER: "REGISTER_USER",
  RESIDENTS_SUBMIT: "RESIDENTS_SUBMIT",
  ROOMS_SUBMIT: "ROOMS_SUBMIT",
  SET_ACTIVE_PROFILE_ELEMENTS: "SET_ACTIVE_PROFILE_ELEMENTS",
  SET_ADDRESS: "SET_ADDRESS",
  SET_CONTENT: "SET_CONTENT",
  SET_ENVIRONMENT: "SET_ENVIRONMENT",
  SET_HOLDING: "SET_HOLDING",
  SET_NEXT_PAGE: "SET_NEXT_PAGE",
  SET_PAGE: "SET_PAGE",
  SET_PAGES: "SET_PAGES",
  SET_PREVIOUS_PAGE: "SET_PREVIOUS_PAGE",
  SET_PROCEED_FROM_HOLDING: "SET_PROCEED_FROM_HOLDING",
  SET_PROFILE_ELEMENTS: "SET_PROFILE_ELEMENTS",
  SET_REQUIRED_FIELDS: "SET_REQUIRED_FIELDS",
  SET_RESIDENT_VACCINATION_OPTIONS: "SET_RESIDENT_VACCINATION_OPTIONS",
  SET_RECAPTCHA_SITE_ID: "SET_RECAPTCHA_SITE_ID",
  SET_LOCAL_PROFILE_ELEMENTS: "SET_LOCAL_PROFILE_ELEMENTS",
  SET_REGISTERED: "SET_REGISTERED",
  SET_RESIDENTS: "SET_RESIDENTS",
  SET_REFERRAL_PROGRAM: "SET_REFERRAL_PROGRAM",
  REQUEST_PHOTOS: "REQUEST_PHOTOS",
  RECEIVE_PHOTOS: "RECEIVE_PHOTOS",
  INVALIDATE_PHOTOS: "INVALIDATE_PHOTOS",
  REQUEST_RESIDENTS: "REQUEST_RESIDENTS",
  RECEIVE_RESIDENTS: "RECEIVE_RESIDENTS",
  INVALIDATE_RESIDENTS: "INVALIDATE_RESIDENTS",
  REQUEST_HOST: "REQUEST_HOST",
  RECEIVE_HOST: "RECEIVE_HOST",
  INVALIDATE_HOST: "INVALIDATE_HOST",
  REQUEST_ROOMS: "REQUEST_ROOMS",
  RECEIVE_ROOMS: "RECEIVE_ROOMS",
  INVALIDATE_ROOMS: "INVALIDATE_ROOMS",
  SET_TERMS: "SET_TERMS",
  SET_TERRITORY: "SET_TERRITORY",
  SET_MARKET: "SET_MARKET",
  SET_AFFILIATE: "SET_AFFILIATE",
  SET_USER: "SET_USER",
  SET_AUTHENTICATED_USER: "SET_AUTHENTICATED_USER",
  SET_WITHDRAWN: "SET_WITHDRAWN",
  SKIP_SUBMIT: "SKIP_SUBMIT",
  SMOKING_SUBMIT: "SMOKING_SUBMIT",
  WITHDRAW_SUBMIT: "WITHDRAW_SUBMIT",
  SET_COMPLETED: "SET_COMPLETED",
  COMPLETE_WIZARD: "COMPLETE_WIZARD",
  SET_LANGUAGE_OPTIONS: "SET_LANGUAGE_OPTIONS",
  SET_ETHNICITY_OPTIONS: "SET_ETHNICITY_OPTIONS",
  SET_UPLOAD_PROGRESS: "SET_UPLOAD_PROGRESS",
  SET_UPLOAD_STATUS: "SET_UPLOAD_STATUS",
  RESET_UPLOAD: "RESET_UPLOAD",
  SET_ADDRESS_VALIDATIONS: "SET_ADDRESS_VALIDATIONS"
};

export default constants;
